import React from "react";

export const PENDING_ACTIONS_HELP_TITLE = "Ações pendentes e alertas";

export function PendingActionsHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Centraliza tudo que o gestor precisa
        revisar ou corrigir após o trabalho no campo — pendências e alertas
        gerados <strong>automaticamente</strong> pela plataforma.
      </p>

      <p>
        <strong>Exemplos do que aparece aqui:</strong>
      </p>
      <ul>
        <li>
          <strong>Encerramento incompleto</strong> — operador esqueceu de
          registrar horímetro ou hodômetro ao sair da máquina;
        </li>
        <li>
          <strong>Odômetro ou horímetro sem variação</strong> — leitura igual
          no início e no fim do trabalho, com possível problema no painel;
        </li>
        <li>
          <strong>Leitura inconsistente de odômetro ou horímetro</strong> —
          valor abaixo da leitura anterior, salto grande ou acima do tempo
          de trabalho;
        </li>
        <li>
          <strong>Abastecimento inconsistente</strong> — litros acima do tanque,
          consumo fora da faixa cadastrada ou horímetro incompatible;
        </li>
        <li>
          <strong>Manutenção vencida</strong> — horímetro atual da máquina
          ultrapassou a revisão programada;
        </li>
        <li>
          <strong>Velocidade acima do limite</strong> — máquina ultrapassou a
          velocidade máxima configurada no cadastro (aparece em tempo real,
          sem esperar o encerramento do trabalho);
        </li>
        <li>
          <strong>Perda de colheita acima do limite</strong> — amostra enviada
          pelo operador ultrapassou a margem tolerada da ordem de serviço mais
          o percentual de alerta configurado (ex.: margem 50 kg/ha + 50% =
          alerta a partir de 75 kg/ha);
        </li>
        <li>
          <strong>Outros alertas</strong> — novos tipos passam a aparecer aqui
          conforme forem implementados na plataforma.
        </li>
      </ul>

      <p>
        <strong>O que fazer:</strong> abra cada item, confira máquina,
        operador e data, e resolva na própria tela (informar leituras finais,
        verificar medidor, analisar o trabalho no rastreamento ou usar{" "}
        <strong>Reconhecer / dispensar</strong> quando o gestor já tratou o
        alerta).
      </p>

      <p>
        Na barra lateral, clique em <strong>Ações pendentes e alertas</strong>{" "}
        para expandir e ver cada tipo de alerta separadamente.
      </p>

      <p>
        O <strong>número vermelho</strong> na barra lateral indica quantos
        itens estão pendentes. Quando tudo estiver resolvido, a lista fica
        vazia.
      </p>
    </>
  );
}
